import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { AnalyticsPage, type AnalyticsSearchState } from '../features/analytics/analytics-page';

/**
 * `catch` keeps a hand-edited or stale URL usable: an unknown range or a
 * Release that no longer exists falls back to the default view rather than
 * rendering an error.
 */
const AnalyticsSearchSchema = z.object({
  range: z.enum(['7d', '30d', '90d']).catch('30d'),
  release: z.union([z.literal('all'), z.uuid()]).catch('all'),
  share: z.union([z.literal('all'), z.uuid()]).catch('all'),
});

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/analytics',
)({ component: AnalyticsRoute, validateSearch: zodValidator(AnalyticsSearchSchema) });

function AnalyticsRoute() {
  const params = Route.useParams();
  const searchState: AnalyticsSearchState = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <AnalyticsPage
      {...params}
      onSearchChange={(next) => void navigate({ search: (previous) => ({ ...previous, ...next }) })}
      searchState={searchState}
    />
  );
}
